<template>
    <div class="carddesign card h-100">
        <div class="card-header" v-html="$strings('main.tiles.LibraryStudySpaces.title')"></div>
        <div class="card-body">
            <p class="card-text" v-html="$strings('main.tiles.LibraryStudySpaces.description')"></p>
            <router-link class="btn btn-primary"
                :to="{ name: $strings('main.tiles.LibraryStudySpaces.link') }">{{ $strings('main.tiles.LibraryStudySpaces.title') }}&nbsp;<i class="bi bi-arrow-right"></i></router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LibraryStudySpacesTile',
        methods: {}
    };
</script>

<style scoped>
</style>
